var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#6A6E7F",
    d: "M20.61 13.24l-1.88-1.47c.02-.23.04-.49.04-.77s-.02-.55-.04-.77l1.88-1.47a.92.92 0 00.22-1.17L18.88 4.2a.912.912 0 00-1.13-.41l-2.22.89c-.42-.31-.87-.57-1.33-.77l-.34-2.35a.898.898 0 00-.9-.78H9.04a.9.9 0 00-.9.78L7.8 3.92c-.45.2-.88.46-1.33.77L4.25 3.8a.923.923 0 00-1.12.4L1.17 7.58c-.23.39-.14.9.22 1.18l1.88 1.47a7.36 7.36 0 000 1.54l-1.88 1.47a.92.92 0 00-.22 1.17l1.95 3.38c.21.38.66.58 1.13.41l2.22-.89c.42.31.87.56 1.33.77l.34 2.35c.06.45.44.79.9.79h3.92a.9.9 0 00.9-.78l.34-2.36c.45-.2.88-.46 1.33-.77l2.22.89a.912.912 0 001.12-.4l1.96-3.4a.91.91 0 00-.22-1.16zM11 14.41c-1.88 0-3.41-1.53-3.41-3.41S9.12 7.59 11 7.59s3.41 1.53 3.41 3.41-1.53 3.41-3.41 3.41z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptSettings);
export default __webpack_public_path__ + "static/media/recrypt_settings.63b5754f.svg";
export { ForwardRef as ReactComponent };